import React, { useState } from 'react';
import styles from './styles.module.css';
import * as translations from '../strings';
import { getLangKey } from 'appJS/models/Language';
import { JavasvcriptContent } from './JavascriptContent';
import { WordpressContent } from './WordpressContent';
import BrowserExtension from 'appJS/views/install_bugherd/browser_extension';
import { InstallOptionCard } from './InstallOptionCard';
import cx from 'classnames';

const strings = translations[getLangKey()];

export enum InstallOptionKeys {
  Javascript = 'javascriptCode',
  Extension = 'browserExtension',
  Wordpress = 'wordpressPlugin'
}

export const InstallBugherd = ({
  onInstallCallback,
  bugherdUrl,
  user,
  project,
  isOnboarding
}: {
  onInstallCallback: (isWordpress?: boolean) => void;
  bugherdUrl: string;
  user?: { admin: boolean };
  project: {
    apiKey: string;
    id: string;
    javascriptInstalledOverride: boolean;
  };
  isOnboarding?: boolean;
}) => {
  const { apiKey } = project;
  const [activeKey, setActiveKey] = useState<InstallOptionKeys>(
    InstallOptionKeys.Javascript
  );

  return (
    <div
      className={cx(styles.installBugherd, {
        [styles.onboarding]: isOnboarding
      })}
    >
      {[
        {
          key: InstallOptionKeys.Javascript,
          content: (
            <JavasvcriptContent
              onInstallCallback={onInstallCallback}
              project={project}
              bugherdUrl={bugherdUrl}
              isOnboarding={!!isOnboarding}
            />
          )
        },
        {
          key: InstallOptionKeys.Extension,
          content: user?.admin ? <BrowserExtension /> : undefined
        },
        {
          key: InstallOptionKeys.Wordpress,
          content: (
            <WordpressContent
              apiKey={apiKey}
              onInstallCallback={() => onInstallCallback(true)}
              isOnboarding={!!isOnboarding}
            />
          )
        }
      ].map(({ key, content }, index: number) => (
        <InstallOptionCard
          key={key}
          itemKey={key}
          title={strings[`${key}Title`]}
          description={strings[`${key}Description`]}
          content={content}
          active={activeKey === key}
          index={index}
          onClick={(callback?: () => void) =>
            key === InstallOptionKeys.Extension
              ? user?.admin
                ? setActiveKey(key)
                : callback?.()
              : setActiveKey(key)
          }
        />
      ))}
    </div>
  );
};
